import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Box, ButtonGroup, Typography, useMediaQuery, Card, CardHeader, CardContent, CardActions, CardActionArea, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider, styled, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction } from "@mui/material"
import Header from './Header'
import { UserAuth } from '../context/AuthContext'
import { useNavigate, useParams } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TokenContext from '../context/TokenContext'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { confirmarOrechazarAsignacion, divisionXasignacion, experiencia, fechasParciales, fechasXasignacion, formacionDocenteXasignacion, horariosXasignacion, limpiarTodosLosEstados, proyectoAcademicoTransversal, proyectoIntervencionComunitaria, proyectoInvestigacion, tareasXasignacion, teamTeaching, transferenciaInvestigacion } from '../Redux/asignaciones'
import { COLUMNSFECHAFINAL, COLUMNSFECHAPARCIAL, COLUMNSFORMACION, COLUMNSHORARIOS, COLUMNSPAT, COLUMNSPI, COLUMNSPIC, COLUMNSTAREAS } from '../columnas/columnasAsignaciones'
import TablaFecha from './tablas/TablaFecha'

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import TablaAsignaciones from './tablas/TablaAsignaciones'

const AceptacionAsignacion = () => {
    const dispatch = useDispatch()
    const theme = useTheme()
    const navigate = useNavigate();
    const token = useContext(TokenContext)
    const { id } = useParams()
    const { empleado } = UserAuth()

    const [valuePrimerTab, setValuePrimerTab] = React.useState('1'); //value del tablist

    //division
    const [division, setDivision] = React.useState([])
    const [loadingDivision, setLoadingDivision] = React.useState(false)
    const divisionXasignacionSelector = useSelector(store => store.asignaciones.division)
    const getDIVISIONselector = useSelector(store => store.asignaciones.getDivision)

    //hooks para el fetch de fecha
    const [materia, setMateria] = React.useState('')
    const [periodo, setPeriodo] = React.useState('')
    const [modalidadDictado, setModalidadDictado] = React.useState('')
    const [divisionID, setDivisionID] = React.useState('')

    //horarios de la division
    const [horarioAsignacion, setHorarioAsignacion] = React.useState([])
    const [loadingHorarios, setLoadingHorarios] = React.useState(false)
    const horariosXasignacionSelector = useSelector(store => store.asignaciones.horarios)
    const getHORARIOSselector = useSelector(store => store.asignaciones.getHorarios)

    //fecha examen final
    const [fechaAsignacion, setFechaAsignacion] = React.useState([])
    const [loadingFechas, setLoadingFechas] = React.useState(false)
    const fechasXasignacionSelector = useSelector(store => store.asignaciones.fechas)
    const getFECHASEXAMENFINALselector = useSelector(store => store.asignaciones.getFechas)

    //fecha examen final
    const [fechaParciales, setFechaParciales] = React.useState([])
    const [loadingFechasPar, setLoadingFechasPar] = React.useState(false)
    const fechasParcialesSelector = useSelector(store => store.asignaciones.fechasParciales)
    const getFECHASPARCIALESselector = useSelector(store => store.asignaciones.getFechasParciales)

    //formacion docente
    const [formacionDoc, setFormacionDoc] = React.useState([])
    const [loadingForma, setLoadingForma] = React.useState(false)
    const formacionDocenteSelector = useSelector(store => store.asignaciones.formacionDocente)
    const getFORMACIONselector = useSelector(store => store.asignaciones.getFormacion)

    //tareas
    const [tareas, setTareas] = React.useState([])
    const [loadingTarea, setLoadingTarea] = React.useState(false)
    const tareasSelector = useSelector(store => store.asignaciones.tareas)
    const getTAREASselector = useSelector(store => store.asignaciones.getTareas)

    //proyecto investigacion
    const [proyectInvestigacion, setProyectInvestigacion] = React.useState([])
    const [loadingPI, setLoadingPI] = React.useState(false)
    const proyectInvestigacionSelector = useSelector(store => store.asignaciones.proyecto)
    const getPROYECTOINVESTIGACIONselector = useSelector(store => store.asignaciones.getProyectoInvestigacion)

    const [PAT, setPAT] = React.useState([])
    const [loadingPAT, setLoadingPAT] = React.useState(false)
    const PATSelector = useSelector(store => store.asignaciones.pat)
    const getPATselector = useSelector(store => store.asignaciones.getPat)

    const [PIC, setPIC] = React.useState([])
    const [loadingPIC, setLoadingPIC] = React.useState(false)
    const PICSelector = useSelector(store => store.asignaciones.pic)
    const getPICselector = useSelector(store => store.asignaciones.getPic)

    React.useEffect(() => {
        // Función de limpieza
        return () => {
          dispatch(limpiarTodosLosEstados());
        };
      }, []); 

    React.useEffect(() => {
        if (id && token && empleado) {
            dispatch(divisionXasignacion(token, id, empleado.usuarioPortalRh))
            dispatch(formacionDocenteXasignacion(token, id, empleado.usuarioPortalRh));
        }
    }, [id, token, empleado]);

    //DIVISION
    React.useEffect(() => {
        if (!getDIVISIONselector) {
            setDivision([]);
            setLoadingDivision(false);
        }
        else if (divisionXasignacionSelector?.length > 0) {
            var array = []
            divisionXasignacionSelector.forEach(element => {
                var objeto = {
                    new_carrera: element["division.new_carreraid@OData.Community.Display.V1.FormattedValue"],
                    new_materia: element["division.new_materia@OData.Community.Display.V1.FormattedValue"],
                    new_modalidaddictado: element["division.new_modalidaddictado@OData.Community.Display.V1.FormattedValue"],
                    new_name: element["division.new_name"],
                    new_periodo: element["division.new_periodo@OData.Community.Display.V1.FormattedValue"],
                    new_tipodedivision: element["division.new_tipodedivision@OData.Community.Display.V1.FormattedValue"],
                    new_divisionid: element["division.new_divisionid"]
                }
                array.push(objeto)
            });
            setDivision(array)

            // Guardar los valores en estados separados
            const firstElement = divisionXasignacionSelector[0];
            setMateria(firstElement["division.new_materia"]);
            setModalidadDictado(firstElement["division.new_modalidaddictado"]);
            setPeriodo(firstElement["division.new_periodo"]);
            setDivisionID(firstElement["division.new_divisionid"])

            setLoadingDivision(true)
        } else {
            setLoadingDivision(true)
        }
    }, [divisionXasignacionSelector, id, getDIVISIONselector])

    React.useEffect(() => {
        if (materia !== '' && periodo !== '' && modalidadDictado !== '' && divisionID !== '') {
            dispatch(fechasXasignacion(token, materia, periodo, modalidadDictado))
            dispatch(fechasParciales(token, divisionID))
            dispatch(horariosXasignacion(token, divisionID))
            dispatch(tareasXasignacion(token, divisionID, empleado.usuarioPortalRh))
            dispatch(teamTeaching(token, divisionID, empleado.usuarioPortalRh))
            dispatch(experiencia(token, divisionID, empleado.usuarioPortalRh))
            dispatch(proyectoInvestigacion(token, divisionID, empleado.usuarioPortalRh))
            dispatch(transferenciaInvestigacion(token, divisionID, empleado.usuarioPortalRh))
            dispatch(proyectoAcademicoTransversal(token, divisionID, empleado.usuarioPortalRh))
            dispatch(proyectoIntervencionComunitaria(token, divisionID, empleado.usuarioPortalRh))
        }
    }, [materia, periodo, modalidadDictado, divisionID, token, id])

    //HORARIOS
    React.useEffect(() => {
        if (!getHORARIOSselector) {
            setHorarioAsignacion([]);
            setLoadingHorarios(false);
        }
        else if (horariosXasignacionSelector?.length > 0) {
            var array = []
            horariosXasignacionSelector.forEach(element => {
                var objeto = {
                    id: element.new_horariosdeladivisionid,
                    new_dia: element["new_dia@OData.Community.Display.V1.FormattedValue"],
                    new_horainicio: element["new_horainicio@OData.Community.Display.V1.FormattedValue"],
                    new_horafin: element["new_horafin@OData.Community.Display.V1.FormattedValue"],
                    new_aula: element["_new_aula_value@OData.Community.Display.V1.FormattedValue"],
                    new_fecha: element.new_fecha
                }
                array.push(objeto)
            });
            setHorarioAsignacion(array)
            setLoadingHorarios(true)
        } else {
            setLoadingHorarios(true)
        }
    }, [horariosXasignacionSelector, id, getHORARIOSselector])
    //FECHA EXAMEN FINAL
    React.useEffect(() => {
        if (fechasXasignacionSelector?.length > 0 && getFECHASEXAMENFINALselector === true) {
            var array = []
            fechasXasignacionSelector.forEach(element => {
                var objeto = {
                    id: element.new_exmenfinalid,
                    new_fechayhora: element["new_fechayhora@OData.Community.Display.V1.FormattedValue"],
                    new_llamadoaexamen: element["new_llamadoaexamen@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setFechaAsignacion(array)
            setLoadingFechas(true)
        } else if (fechasXasignacionSelector?.length == 0 && getFECHASEXAMENFINALselector === true) {
            setLoadingFechas(true)
        }
    }, [fechasXasignacionSelector])
    //FECHA PARCIALES
    React.useEffect(() => {
        if (fechasParcialesSelector?.length > 0 && getFECHASPARCIALESselector === true) {
            var array = []
            fechasParcialesSelector.forEach(element => {
                var objeto = {
                    id: element.new_eventospordivisionid,
                    new_materia: element["division.new_materia@OData.Community.Display.V1.FormattedValue"],
                    new_clasedeparcial: element["new_clasedeparcial@OData.Community.Display.V1.FormattedValue"],
                    new_fechayhorainicio: element["new_fechayhorainicio@OData.Community.Display.V1.FormattedValue"],
                }
                array.push(objeto)
            });
            setFechaParciales(array)
            setLoadingFechasPar(true)
        } else if (fechasParcialesSelector?.length == 0 && getFECHASPARCIALESselector === true) {
            setLoadingFechasPar(true)
        }
    }, [fechasXasignacionSelector])
    //FORMACION
    React.useEffect(() => {
        if (formacionDocenteSelector?.length > 0 && getFORMACIONselector === true) {
            var array = []
            formacionDocenteSelector.forEach(element => {
                var objeto = {
                    id: element.new_cursoid,
                    new_name: element.new_name,
                    new_tipodeformacion: element["new_tipodeformacion@OData.Community.Display.V1.FormattedValue"],
                    cr879_tipodeexperienciadeaprendizaje: element["cr879_tipodeexperienciadeaprendizaje@OData.Community.Display.V1.FormattedValue"],
                    new_formacindocente_new_asignacin: element["ak.new_asignacin@OData.Community.Display.V1.FormattedValue"],
                    new_formacindocente_new_curso: element["ak.new_curso@OData.Community.Display.V1.FormattedValue"],
                    new_formacindocenteid: element["ak.new_formacindocenteid"],
                    new_formacindocente_statuscode: element["ak.statuscode@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setFormacionDoc(array)
            setLoadingForma(true)
        } else if (formacionDocenteSelector?.length == 0 && getFORMACIONselector === true) {
            setLoadingForma(true)
        }
    }, [formacionDocenteSelector])
    //TAREAS
    React.useEffect(() => {
        if (tareasSelector?.length > 0 && getTAREASselector === true) {
            var array = []
            tareasSelector.forEach(element => {
                var objeto = {
                    id: element.activityid,
                    subject: element.subject,
                    scheduledstart: element["scheduledstart@OData.Community.Display.V1.FormattedValue"],
                    scheduledend: element["scheduledend@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element._new_materia_value,
                    new_materia: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setTareas(array)
            setLoadingTarea(true)
        } else if (tareasSelector?.length == 0 && getTAREASselector === true) {
            setLoadingTarea(true)
        }
    }, [tareasSelector])
    //PROYECTO INVESTIGACION
    React.useEffect(() => {
        if (proyectInvestigacionSelector?.length > 0 && getPROYECTOINVESTIGACIONselector === true) {
            var array = []
            proyectInvestigacionSelector.forEach(element => {
                var objeto = {
                    id: element.new_proyectosdeinvestigacinid,
                    new_name: element.new_name,
                    new_fechadeinicio: element["new_fechadeinicio@OData.Community.Display.V1.FormattedValue"],
                    new_fechadefinalizacin: element["new_fechadefinalizacin@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element._new_materia_value,
                    new_materia: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_division_value: element._new_division_value,
                    new_division: element["_new_division_value@OData.Community.Display.V1.FormattedValue"],
                    _new_matriz_value: element._new_matriz_value,
                    new_matriz: element["_new_matriz_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setProyectInvestigacion(array)
            setLoadingPI(true)
        } else if (proyectInvestigacionSelector?.length == 0 && getPROYECTOINVESTIGACIONselector === true) {
            setLoadingPI(true)
        }
    }, [proyectInvestigacionSelector])
    //PROYECTO ACADEMICO TRANSVERSAL
    React.useEffect(() => {
        if (PATSelector?.length > 0 && getPATselector === true) {
            var array = []
            PATSelector.forEach(element => {
                var objeto = {
                    id: element.new_proyectoacadmicotransversalpatid,
                    new_name: element.new_name,
                    _new_division_value: element._new_division_value,
                    new_division: element["_new_division_value@OData.Community.Display.V1.FormattedValue"],
                    new_fechadeinicio: element["new_fechadeinicio@OData.Community.Display.V1.FormattedValue"],
                    new_fechadefinalizacin: element["new_fechadefinalizacin@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element._new_materia_value,
                    new_materia: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_matriz_value: element._new_matriz_value,
                    new_matriz: element["_new_matriz_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setPAT(array)
            setLoadingPAT(true)
        } else if (PATSelector?.length == 0 && getPATselector === true) {
            setLoadingPAT(true)
        }
    }, [PATSelector])
    //PROYECTO DE INTERVENCION COMUNITARIA
    React.useEffect(() => {
        if (PICSelector?.length > 0 && getPICselector === true) {
            var array = []
            PICSelector.forEach(element => {
                var objeto = {
                    id: element.new_proyectosdeintervencincomunitariapicid,
                    createdon: element["createdon@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    _new_division_value: element._new_division_value,
                    new_division: element["_new_division_value@OData.Community.Display.V1.FormattedValue"],
                    new_fechadeinicio: element["new_fechadeinicio@OData.Community.Display.V1.FormattedValue"],
                    new_fechadefinalizacin: element["new_fechadefinalizacin@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element._new_materia_value,
                    new_materia: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_matriz_value: element._new_matriz_value,
                    new_matriz: element["_new_matriz_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setPIC(array)
            setLoadingPIC(true)
        } else if (PICSelector?.length == 0 && getPICselector === true) {
            setLoadingPIC(true)
        }
    }, [PICSelector])

    const handleChangePrimerTAB = (event, newValue) => {
        setValuePrimerTab(newValue);
    };

    const handleVolverAtras = () => {
        navigate('/asignaciones');
    };

    const cardStyle = {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.tertiary[600],
        borderRadius: '8px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        padding: '16px',
        // width: '400px',
        // margin: '0 auto',
    };

    const titleStyle = {
        fontWeight: 'bold',
        marginBottom: '8px',
        color: '#fff'
    };

    const infoStyle = {
        marginBottom: '4px',
        color: '#fff'
    };

    const [accepted, setAccepted] = React.useState(false);
    const [rejected, setRejected] = React.useState(false);

    const handleAccept = () => {
        setAccepted(true);
        setRejected(false);
        dispatch(confirmarOrechazarAsignacion(token, id, 100000000))
            .then(() => {
                // Promesa cumplida, redirige a la ruta '/asignaciones'
                navigate('/asignaciones');
            })
            .catch((error) => {
                // Manejar el error de la promesa si es necesario
                console.log(error)
            });
    };

    const handleReject = () => {
        setAccepted(false);
        setRejected(true);
        dispatch(confirmarOrechazarAsignacion(token, id, 100000001))
            .then(() => {
                // Promesa cumplida, redirige a la ruta '/asignaciones'
                navigate('/asignaciones');
            })
            .catch((error) => {
                // Manejar el error de la promesa si es necesario
                console.log(error)
            });
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Button variant="outlined" onClick={handleVolverAtras} sx={{ mb: 4 }} color='secondary'>
                    <IconButton color='secondary'>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography color='secondary'>Volver atrás</Typography>
                </Button>

                <Header title={"Aceptación de asignación"} subtitle="En este espacio podrá Aceptar o Rechazar las asignaciones propuestas por la Universidad, así como tener la información referente a ellas." />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} sx={{ mt: 2, pt: 4 }}>
                        {
                            !loadingDivision ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress color="secondary" />
                                </Box>
                            )
                                : division.length > 0 ? (
                                    <Card
                                        style={cardStyle}
                                    >
                                        <CardContent>
                                            {division.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <Typography variant="h6" style={titleStyle}>
                                                        Nombre: {item.new_name}
                                                    </Typography>
                                                    <Typography variant="body1" style={infoStyle}>
                                                        Carrera: {item.new_carrera}
                                                    </Typography>
                                                    <Typography variant="body1" style={infoStyle}>
                                                        Materia: {item.new_materia}
                                                    </Typography>
                                                    <Typography variant="body1" style={infoStyle}>
                                                        Período: {item.new_periodo}
                                                    </Typography>
                                                    <Typography variant="body1" style={infoStyle}>
                                                        Tipo de División: {item.new_tipodedivision}
                                                    </Typography>
                                                    <Typography variant="body1" style={infoStyle}>
                                                        Modalidad de Dictado: {item.new_modalidaddictado}
                                                    </Typography>
                                                </React.Fragment>
                                            ))}
                                        </CardContent>
                                    </Card>
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        No existen registros de — <strong>Division</strong>.
                                    </Alert>
                        }
                    </Grid>
                    <Grid item xs={12} sm={8} sx={{ mt: 2 }}>
                        <TabContext value={valuePrimerTab}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <TabList
                                    aria-label="scrollable force tabs example"
                                    onChange={handleChangePrimerTAB} variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    textColor="secondary"
                                    indicatorColor="secondary"
                                >
                                    <Tab label="Horarios de la división" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Fecha examen final" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Fecha exámenes parciales" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                </TabList>
                            </Box>
                            <TabPanel value="1">
                                {
                                    !loadingHorarios ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    ) :
                                        horarioAsignacion.length > 0 ? (
                                            <TablaFecha columnas={COLUMNSHORARIOS} lineas={horarioAsignacion} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                No existen registros de — <strong>Horarios de la division</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                            <TabPanel value="2">
                                {
                                    !loadingFechas ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    ) :
                                        fechaAsignacion.length > 0 ? (
                                            <TablaFecha columnas={COLUMNSFECHAFINAL} lineas={fechaAsignacion} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                No existen registros de — <strong>Fechas de examen</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                            <TabPanel value="3">
                                {
                                    !loadingFechasPar ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    ) :
                                        fechaParciales.length > 0 ? (
                                            <TablaFecha columnas={COLUMNSFECHAPARCIAL} lineas={fechaParciales} />
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                No existen registros de — <strong>Fechas de examenes parciales</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                        </TabContext>

                    </Grid>

                </Grid>


                <Grid item xs={12} sm={8} sx={{ mt: 2 }}>
                    {
                        !loadingForma ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    py: 2
                                }}>
                                <CircularProgress color="secondary" />
                            </Box>
                        ) :
                            formacionDoc.length > 0 ? (
                                <>
                                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }} color="secondary">
                                            Formación docente
                                        </Typography>
                                    </Box>
                                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                            A continuación podrá visualizar la formación que se requiere cumplimentar para el dictado de la asignatura.
                                        </Typography>
                                    </Box>
                                    <TablaAsignaciones columnas={COLUMNSFORMACION} lineas={formacionDoc} />
                                </>
                            ) :
                                <Alert severity="info">
                                    <AlertTitle>Info</AlertTitle>
                                    No existen registros de — <strong>Formación docente</strong>.
                                </Alert>
                    }
                </Grid>
                <Grid item xs={12} sm={8} sx={{ mt: 2 }}>

                    {
                        !loadingTarea ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    py: 2
                                }}>
                                <CircularProgress color="secondary" />
                            </Box>
                        ) :
                            tareas.length > 0 ? (
                                <>
                                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }} color="secondary">
                                            Tareas
                                        </Typography>
                                    </Box>
                                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                            Asignación sujeta a la apertura por la inscripción de alumnos.
                                        </Typography>
                                    </Box>
                                    <TablaAsignaciones columnas={COLUMNSTAREAS} lineas={tareas} />
                                </>
                            ) :
                                <Alert severity="info">
                                    <AlertTitle>Info</AlertTitle>
                                    No existen registros de — <strong>Tareas</strong>.
                                </Alert>
                    }

                </Grid>

                <Grid item xs={12} sm={8} sx={{ mt: 2 }}>

                    {
                        !loadingPI ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    py: 2
                                }}>
                                <CircularProgress color="secondary" />
                            </Box>
                        ) :
                            proyectInvestigacion.length > 0 ? (
                                <>
                                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }} color="secondary">
                                            Proyecto de investigación
                                        </Typography>
                                    </Box>
                                    <TablaAsignaciones columnas={COLUMNSPI} lineas={proyectInvestigacion} />
                                </>
                            ) :
                                <Alert severity="info">
                                    <AlertTitle>Info</AlertTitle>
                                    No existen registros de — <strong>Proyectos de investigación</strong>.
                                </Alert>
                    }

                </Grid>

                <Grid item xs={12} sm={8} sx={{ mt: 2 }}>

                    {
                        !loadingPAT ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    py: 2
                                }}>
                                <CircularProgress color="secondary" />
                            </Box>
                        ) :
                            PAT.length > 0 ? (
                                <>
                                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }} color="secondary">
                                            Proyecto académico transversal (PAT)
                                        </Typography>
                                    </Box>
                                    <TablaAsignaciones columnas={COLUMNSPAT} lineas={PAT} />
                                </>
                            ) :
                                <Alert severity="info">
                                    <AlertTitle>Info</AlertTitle>
                                    No existen registros de — <strong>Proyecto académico transversal</strong>.
                                </Alert>
                    }

                </Grid>

                <Grid item xs={12} sm={8} sx={{ mt: 2 }}>

                    {
                        !loadingPIC ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    py: 2
                                }}>
                                <CircularProgress color="secondary" />
                            </Box>
                        ) :
                            PIC.length > 0 ? (
                                <>
                                    <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                                        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }} color="secondary">
                                            Proyecto de intervención comunitaria (PIC)
                                        </Typography>
                                    </Box>
                                    <TablaAsignaciones columnas={COLUMNSPIC} lineas={PIC} />
                                </>
                            ) :
                                <Alert severity="info">
                                    <AlertTitle>Info</AlertTitle>
                                    No existen registros de — <strong>Proyecto de intervención comunitaria</strong>.
                                </Alert>
                    }

                </Grid>

                <Box display="flex" flexDirection="column" alignItems="center">
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>¿Deseas aceptar o rechazar la asignación?</Typography>
                    <ButtonGroup>
                        <Button
                            variant={accepted ? 'contained' : 'outlined'}
                            onClick={handleAccept}
                            disabled={accepted || rejected}
                            color="success"
                        >
                            Aceptar
                        </Button>
                        <Button
                            variant={rejected ? 'contained' : 'outlined'}
                            onClick={handleReject}
                            disabled={accepted || rejected}
                            color="error"
                        >
                            Rechazar
                        </Button>
                    </ButtonGroup>
                </Box>
            </Box>
        </motion.div>
    )
}

export default AceptacionAsignacion